/* eslint-disable consistent-return */
import { createActions } from 'redux-actions';
import { addFlashMessage, clearMessage } from '../Flash';
import api from '../../../api';
import {
  normalizeJsonProject,
  getErrorMessages,
} from '../../../shared/helpers/';

export const {
  selectProject,
  getUserProjectsSuccess,
  createProjectSuccess,
  selectProjectRequest,
  createProjectRequest,
  createProjectFailure,
  getUserProjectsRequest,
  getUserProjectsFailure,
  removeProject,
  saveProjectRequest,
  saveProjectSuccess,
  saveProjectFailure,
  removeProjectRequest,
} = createActions(
  {
    SELECT_PROJECT: (projectId, selectedProject) => ({
      project_id: projectId,
      selected_project: selectedProject,
    }),
    GET_USER_PROJECTS_SUCCESS: data => ({ data }),
    CREATE_PROJECT_SUCCESS: data => ({ data }),
  },
  'SELECT_PROJECT_REQUEST',
  'CREATE_PROJECT_REQUEST',
  'CREATE_PROJECT_FAILURE',
  'GET_USER_PROJECTS_REQUEST',
  'GET_USER_PROJECTS_FAILURE',
  'REMOVE_PROJECT',
  'SAVE_PROJECT_REQUEST',
  'SAVE_PROJECT_SUCCESS',
  'SAVE_PROJECT_FAILURE',
  'REMOVE_PROJECT_REQUEST',
);

export const fetchUserProjects = () => dispatch => {
  dispatch(clearMessage());
  dispatch(getUserProjectsRequest());

  return api
    .fetchProjects()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      const normalized = normalizeJsonProject(json);
      return dispatch(getUserProjectsSuccess(normalized));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));

      return dispatch(getUserProjectsFailure());
    });
};

export const discardProject = project => dispatch => {
  dispatch(clearMessage());
  dispatch(removeProjectRequest());

  return api
    .discardProject(project.id)
    .then(json => {
      if (json.errors) {
        dispatch(addFlashMessage(json.errors, 'error'));
        return;
      }

      dispatch(removeProject(project));
      dispatch(addFlashMessage(['Project discarded'], 'success'));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};

export const createNewProject = loggedUser => dispatch => {
  dispatch(clearMessage());
  dispatch(createProjectRequest());
  return api
    .createProject({ email: loggedUser })
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        dispatch(addFlashMessage(json.errors, 'error'));
        return;
      }
      const normalized = normalizeJsonProject(json);
      return dispatch(selectProject(normalized.id, normalized));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
      return dispatch(createProjectFailure());
    });
};

export const saveProgress = (
  data,
  projectId,
  isFetchingProjects = false,
) => dispatch => {
  dispatch(saveProjectRequest());
  return api
    .saveProject(data, projectId)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      const action = dispatch(saveProjectSuccess());
      if (!isFetchingProjects) {
        const normalized = normalizeJsonProject(json);
        dispatch(selectProject(normalized.id, normalized));
      }
      return action;
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
      dispatch(saveProjectFailure());
      dispatch(getUserProjectsFailure());
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/Dashboard/index.js